import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
// import {MessageBox} from 'element-ui';
// import store from '../store'
// import {logout} from "@/api/user";

Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '首页',
      // component: Layout,
      component: resolve => require(['@/views/Login'], resolve)
    },
    {
      path: '/errorPage',
      name: '错误',
      // component: Layout,
      component: resolve => require(['@/views/errorPage'], resolve)
    },
    {
      path: '/login',
      name: '登录',
      component: resolve => require(['@/views/Login'], resolve)
    },
    {
      path: '/notice',
      component: Layout,
      hidden: true,
      name: '公告',
      children: [
        {
          name: '公告',
          path: '/',
          component: resolve => require(['@/views/notice'], resolve),
        }
      ]
    },
    {
      path: '/userCenter',
      component: Layout,
      hidden: true,
      name: '用户中心',
      children: [
        {
          name: '首页',
          path: '/',
          component: resolve => require(['@/views/userCenter'], resolve),
        }
      ]
    },
    {
      path: '/message',
      component: Layout,
      hidden: true,
      name: '我的消息',
      children: [
        {
          name: '我的消息',
          path: '/message',
          component: resolve => require(['@/views/myMessage'], resolve),
        }
      ]
    },
    {
      path: '/myInterface',
      component: Layout,
      hidden: true,
      name: '我的数据接口',
      children: [
        {
          name: '数据接口',
          path: 'myInterface',
          component: resolve => require(['@/views/myInterface/myInterface'], resolve),
        },
        {
          name: '套餐购买',
          path: 'purchaseInterface',
          component: resolve => require(['@/views/myInterface/purchaseInterface'], resolve),
        },
        {
          name: '套餐预警值',
          path: 'packageRemind',
          component: resolve => require(['@/views/myInterface/packageRemind'], resolve),
        },
        {
          name: '数据包购买',
          path: 'datapacket',
          component: resolve => require(['@/views/myInterface/datapacket'], resolve),
        },
        {
          name: '短信服务',
          path: 'shortMessage',
          component: resolve => require(['@/views/myInterface/shortMessage'], resolve),
        }
      ]
    },
    {
      path: '/myAccount',
      component: Layout,
      hidden: true,
      name: '我的账户',
      children: [
        {
          name: '业务查询',
          path: 'personAccount',
          component: resolve => require(['@/views/myAccount/personAccount'], resolve),
        },
        {
          name: '业务充值',
          path: 'recharge',
          component: resolve => require(['@/views/myAccount/recharge'], resolve),
        },
        {
          name: '金币明细',
          path: 'detailed',
          component: resolve => require(['@/views/myAccount/detailed'], resolve),
        },
        {
          name: '余额提示设置',
          path: 'warningMoney',
          component: resolve => require(['@/views/myAccount/warningMoney'], resolve),
        }
      ]
    },
    {
      path: '/billing',
      component: Layout,
      hidden: true,
      name: '发票管理',
      children: [
        {
          name: '发票申请',
          path: 'billing',
          component: resolve => require(['@/views/billManage/billing'], resolve),
        },
        {
          name: '发票列表',
          path: 'invoiceList',
          component: resolve => require(['@/views/billManage/invoiceList'], resolve),
        },
        {
          name: '发票信息管理',
          path: 'invoiceInfo',
          component: resolve => require(['@/views/billManage/invoiceInfo'], resolve),
        },
        {
          name: '寄送地址',
          path: 'invoiceAddress',
          component: resolve => require(['@/views/billManage/invoiceAddress'], resolve),
        },
        {
          name: '实名认证',
          path: 'authentication',
          component: resolve => require(['@/views/billManage/authentication'], resolve),
        }
      ]
    },
    {
      path: 'feedback',
      component: Layout,
      hidden: true,
      name: '意见反馈',
      children: [
        {
          name: '意见反馈',
          path: '/feedback',
          component: resolve => require(['@/views/feedback'], resolve),
        }
      ]
    },
    {
      path: '/editInfo',
      component: Layout,
      hidden: true,
      name: '用户设置',
      children: [
        {
          name: '设置信息',
          path: 'editInfo',
          component: resolve => require(['@/views/userSettings/editInfo'], resolve),
        },
        {
          name: '修改密码',
          path: 'changePassword',
          component: resolve => require(['@/views/userSettings/changePassword'], resolve),
        },
        {
          name: '安全设置',
          path: 'securitySetting',
          component: resolve => require(['@/views/userSettings/securitySetting'], resolve),
        }
      ]
    },
    {
      path: 'uservip',
      component: Layout,
      hidden: true,
      name: '会员优惠',
      children: [
        {
          name: '会员优惠',
          path: '/uservip',
          component: resolve => require(['@/views/vipDiscount'], resolve),
        }
      ]
    }
  ]
});

// router.beforeEach((to, from, next) => {
//   if (to.path === '/' && from.path !== '/') {
//     MessageBox.prompt('确认退出登录？', '提示', {
//       type: 'warning',
//       showInput: false,
//       confirmButtonText: "确定",
//       cancelButtonText: "取消",
//       beforeClose: (action, instance, done) => {
//         if (action === "confirm") {
//           next();
//           MessageBox.close();
//           logout().then(response => {
//             localStorage.clear();
//             store.commit('emptyVisitedView');
//           }).catch(e => {
//             localStorage.clear();
//             store.commit('emptyVisitedView');
//           });
//         } else {
//           next();
//           router.push({path: from.path});
//           MessageBox.close()
//         }
//       }
//     })
//   } else {
//     next();
//   }
// });

export default router



// WEBPACK FOOTER //
// ./src/router/index.js